/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import classNames from 'classnames';
import * as React from 'react';

import { mapToCssModules } from '../common/utilities';
import { IPaginationItemProps } from './PaginationItem.props';

/**
 * PaginationItem component.
 */
export default class PaginationItem extends React.PureComponent<IPaginationItemProps> {
    public static defaultProps: Partial<IPaginationItemProps> = {
        tag: 'li'
    };

    public render(): JSX.Element {
        const { active, className, cssModule, disabled, tag: Tag, ...props }: any = this.props;

        const paginationItemClasses = mapToCssModules(
            classNames(className, 'msc-page-item', {
                active,
                disabled
            }),
            cssModule
        );

        return <Tag {...props} className={paginationItemClasses} />;
    }
}
